const initialState = {
  filter: [],
  loading: true,
  status: null
};

export default initialState;



// WEBPACK FOOTER //
// ./source/client/reducers/common/working_shift_groups/initialState.js